<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"
        ><i class="fas fa-edit"></i>&nbsp;Edit</b-button
      >
    </slot>

    <b-modal
      @show="onShow"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="ID" label-for="id-input" v-if="!this.create">
          <b-form-input
            id="id-input"
            v-model="formValues.id"
            autocomplete="off"
            disabled
          />
        </b-form-group>

        <b-form-group label="Source" label-for="source-input">
          <b-form-input
            hidden
            id="source-input"
            v-model="formValues.sourceId"
            v-validate="{ required: true }"
            :state="validateState('source-input')"
            data-vv-name="source-input"
            data-vv-as="Source"
            aria-describedby="source-input-live-feedback"
          ></b-form-input>
          <multiselect
            id="source-select"
            v-model="formValues.sourceId"
            :options="sourceOptions"
            :custom-label="
              opt => this.$store.getters['sourcesModule/getName'](opt)
            "
            :multiple="false"
            :placeholder="$t('Select')"
            :select-label="$t('Press enter to select')"
            :selected-label="$t('Selected')"
            :loading="!this.$store.getters['sourcesModule/loaded']"
            :disabled="!this.$store.getters['sourcesModule/loaded']"
          />
          <b-form-invalid-feedback id="source-input-live-feedback">
            {{ veeErrors.first('source-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="API Key" label-for="api-key">
          <b-form-input
            id="api-key-input"
            v-model="formValues.apiKey"
            v-validate="{ required: true }"
            :state="validateState('api-key-input')"
            aria-describedby="api-key-input-live-feedback"
            data-vv-name="api-key-input"
            data-vv-as="API Key"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="api-key-input-live-feedback">
            {{ veeErrors.first('api-key-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Slave ID" label-for="slave-id">
          <b-form-input
            id="slave-id-input"
            v-model.number="formValues.slaveId"
            type="number"
            v-validate="'required|numeric'"
            :state="validateState('slave-id-input')"
            aria-describedby="slave-id-input-live-feedback"
            data-vv-name="slave-id-input"
            data-vv-as="Slave ID"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="slave-id-input-live-feedback">
            {{ veeErrors.first('slave-id-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="URL/IP" label-for="url-input">
          <b-form-input
            id="url-input"
            v-model="formValues.url"
            v-validate="{ required: true }"
            :state="validateState('url-input')"
            aria-describedby="url-input-live-feedback"
            data-vv-name="url-input"
            data-vv-as="URL"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="url-input-live-feedback">
            {{ veeErrors.first('url-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="formValues.staticUrl"
            :value="true"
            :unchecked-value="false"
            >staticUrl</b-form-checkbox
          >
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit"
        >Save</b-button
      >
    </b-modal>
  </span>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Vue from 'vue'

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues()
    }
  },
  components: {
    Multiselect
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        sourceId: null,
        apiKey: null,
        slaveId: null,
        url: null,
        staticUrl: false
      }
    },
    setDefaults() {
      let initialValues = this.getInitialValues()

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field])
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field])
        }
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    async onShow() {
      this.setDefaults()
    },
    resetModal() {
      this.setDefaults()
    },
    hideModal() {
      this.$refs['modal-container'].hide()
    },
    toggle() {
      this.modalShow = !this.modalShow
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }

        this.$http({
          url: this.create
            ? '/api/v1/source-proxies'
            : '/api/v1/source-proxies/' + this.formValues.id,
          method: this.create ? 'POST' : 'PUT',
          data: {
            ...this.formValues
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish')
            }, 500)

            this.hideModal()
            this.$toastr.i('Success')
          })
          .catch(err => {
            this.$toastr.e(JSON.stringify(err.response.data.message))

            throw err
          })
      })
    }
  },
  computed: {
    sourceOptions() {
      return this.$store.getters['sourcesModule/list'].map(source => source.id)
    }
  },
  mounted() {
    this.setDefaults()
  }
}
</script>
